import React, { ReactElement } from 'react';

export default function Healthcheck(): ReactElement {
	return (
		<div>
			<p>The site is health</p>
		</div>
	);
}
